import {create} from 'zustand'

export const useCompaniesToSwitch = create(set => ({
  companiesToSwitch: [],
  setCompaniesToSwitch: data => set({companiesToSwitch: data}),
}))
